import Axios from "axios";
import Swal from "sweetalert2";
import { getCurrentYearMonth } from "./DateUtils";
import { useEffect } from "react";

// ดึงข้อมูลจาก Table ใดๆ ก็ได้
const getData = async (table, where) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-data`,
      {
        table: table,
        where: where,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ แต่ต้องเป็น Comp_Id ตามล็อกอิน
const getDataWithComp = async (table, order, limit = null, columns = "*") => {
  try {
    const payload = {
      table: table,
      order: order,
      comp_id: window.localStorage.getItem("company"),
      columns: columns, // เพิ่มการส่ง columns parameter
    };

    // เพิ่ม limit ถ้ามี (สำหรับ optimize performance)
    if (limit && typeof limit === "number" && limit > 0) {
      payload.limit = limit;
    }

    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-data-with-comp`,
      payload,
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ และสามารถ JOIN Table ได้ด้วย
const getDataWithJoin = async (select, table, join, order) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-data-with-join`,
      {
        select: select,
        table: table,
        join: join,
        order: order,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

const searchItemsWithStock = async (
  whId,
  keyword,
  showInactive = false,
  filterOnhand = false,
) => {
  try {
    const compId = window.localStorage.getItem("company");

    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/search-items-with-stock`,
      {
        comp_id: compId,
        wh_id: whId,
        keyword,
        show_inactive: showInactive,
        filter_onhand: filterOnhand,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );

    console.debug(" /search-items-with-stock", response.status, response.data);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error(" /search-items-with-stock", {
      status: error.response?.status,
      data: error.response?.data,
    });
    return []; 
  }
};

// นับรายการจาก Table ใดๆ ก็ได้ แต่ต้องเป็น Comp_Id ตามล็อกอิน
const countData = async (table, where) => {
  const response = await Axios.post(
    `${process.env.REACT_APP_API_URL}/api/count-data`,
    {
      table: table,
      where: where,
      comp_id: window.localStorage.getItem("company"),
    },
    {
      headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
    },
  );
  return response.data[0].Count;
};

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ โดยใช้ DocId
const getByDocId = async (table, docId, andOrder) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-by-doc-id`,
      {
        table: table,
        doc_id: docId,
        and_order: andOrder,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ โดยใช้ RecId
const getByRecId = async (table, recId, andOrder) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-by-rec-id`,
      {
        table: table,
        rec_id: recId,
        and_order: andOrder,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Table ใดๆ ก็ได้ โดยใช้ PayId
const getByPayId = async (table, payId, andOrder) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-by-pay-id`,
      {
        table: table,
        pay_id: payId,
        and_order: andOrder,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Tb_Set_Company
const getCompany = async () => {
  try {
    const response = await Axios.get(
      `${process.env.REACT_APP_API_URL}/api/get-company`,
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Tb_Set_DocType
const getDocType = async (docCode) => {
  try {
    // const response = await Axios.get(`${process.env.REACT_APP_API_URL}/api/get-doc-type`, {
    //     headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
    // });
    // return response.data;

    const response = await getData(
      "Tb_Set_DocType",
      `DocType_Status = 'Y' AND DocType_DocCode = ${docCode}`,
    );

    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Tb_Set_TransType
const getTransType = async () => {
  try {
    const response = await Axios.get(
      `${process.env.REACT_APP_API_URL}/api/get-trans-type`,
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก Tb_Set_DocStatusColour
const getDocStatusColour = async (docCode, docField) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-doc-status-colour`,
      {
        doc_code: docCode,
        doc_field: docField,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก View_Set_Pr
const getViewPrH = async () => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-pr-h`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก View_Set_Po
const getViewPoH = async () => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-po-h`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก View_Set_Ap
const getViewAp = async () => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-ap`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก View_Set_Item
const getViewItem = async () => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-view-item`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลจาก API_0701_SO_H ที่ยังไม่ได้สร้าง Picking List
const getSoWithoutPK = async () => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-so-by-picking-list`,
      {
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลลูกค้าจาก API_1001_WHDOC_H ที่ GROUP BY เฉพาะลูกค้า
const getCustByType = async (whDocType) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-cust-by-wh-doc-type`,
      {
        wh_doc_type: whDocType,
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ดึงข้อมูลลูกค้าจาก API_1001_WHDOC_H ที่ GROUP BY เฉพาะพนักงาน
const getEmpByType = async (wtDocType) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-emp-by-wh-doc-type`,
      {
        wt_doc_type: wtDocType,
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// Popup แจ้งเตือน ต่างๆ
const getAlert = (status, message, callback) => {
  let icon = "";
  let confirmButtonClass = "";
  let cancelButtonClass = "btn btn-danger"; // Default cancel button class

  switch (status) {
    case "OK":
      icon = "success";
      confirmButtonClass = "btn btn-success";
      break;
    case "FAILED":
      icon = "error";
      confirmButtonClass = "btn btn-danger";
      break;
    case "WARNING":
      icon = "warning";
      confirmButtonClass = "btn btn-warning";
      break;
    case "INFO":
      icon = "info";
      confirmButtonClass = "btn btn-info";
      break;
    case "C_DIALOG":
      icon = message === "ยืนยันการลบข้อมูล" ? "question" : "info";
      confirmButtonClass = "btn btn-lg btn-success";
      cancelButtonClass = "btn btn-lg btn-danger";
      Swal.fire({
        title: message,
        icon: icon,
        showCancelButton: true,
        buttonsStyling: true, // ปิดการใช้งาน styling เริ่มต้นของปุ่ม
        customClass: {
          title: "swal-title-lg",
          confirmButton: confirmButtonClass,
          cancelButton: cancelButtonClass,
        },
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          if (callback) {
            callback(true);
          }
        } else {
          if (callback) {
            callback(false);
          }
        }
      });
      return; // ออกจากฟังก์ชันไม่ต้องทำงานต่อ
    case "WARNING_LIST": {
      icon = "warning";
      confirmButtonClass = "btn btn-warning";

      // รับข้อมูลเป็น object { title, items: [] }
      // items = [{ code: 'ABC', name: 'สินค้า' }, ...]
      let htmlContent = "";

      if (typeof message === "object" && message.items) {
        htmlContent = `<div style="text-align: left;">`;

        if (message.title) {
          htmlContent += `<p style="font-weight: bold; margin-bottom: 10px;">${message.title}</p>`;
        }

        // แสดงรายการเป็น list
        htmlContent += `<ul style="list-style: none; padding-left: 0;">`;
        message.items.forEach((item) => {
          htmlContent += `<li style="margin: 5px 0; padding: 5px; background: #fff3cd; border-left: 3px solid #ffc107;">
            <strong>${item.code || ""}</strong>: ${item.name || ""}
          </li>`;
        });
        htmlContent += `</ul>`;
        htmlContent += `</div>`;
      } else {
        // fallback ถ้าส่งมาแบบข้อความธรรมดา
        htmlContent = String(message).replace(/\n/g, "<br/>");
      }

      Swal.fire({
        html: htmlContent,
        icon,
        buttonsStyling: false,
        customClass: {
          confirmButton: confirmButtonClass,
        },
        confirmButtonText: "ตกลง",
      }).then((result) => {
        // ✅ เพิ่ม callback เพื่อให้สามารถปิด modal และรีเฟรชได้
        if (callback) callback(!!result.isConfirmed);
      });

      return;
    }
    case "WARNING_LIST_CONFIRM": {
      icon = "warning";
      confirmButtonClass = "btn btn-lg btn-success";
      cancelButtonClass = "btn btn-lg btn-danger";

      // รับข้อมูลเป็น object { title, cannotDelete: [], canDelete: [], question }
      let htmlContent = `<div style="text-align: left;">`;

      if (message.title) {
        htmlContent += `<p style="font-weight: bold; margin-bottom: 10px;">${message.title}</p>`;
      }

      // รายการที่ลบไม่ได้
      if (message.cannotDelete && message.cannotDelete.length > 0) {
        htmlContent += `<p style="font-weight: bold; color: #d9534f; margin-top: 15px;">ลบไม่ได้:</p>`;
        htmlContent += `<ul style="list-style: none; padding-left: 0;">`;
        message.cannotDelete.forEach((item) => {
          htmlContent += `<li style="margin: 5px 0; padding: 5px; background: #f8d7da; border-left: 3px solid #d9534f;">
            <strong>${item.code || ""}</strong>: ${item.name || ""}
          </li>`;
        });
        htmlContent += `</ul>`;
      }

      // รายการที่ลบได้
      if (message.canDelete && message.canDelete.length > 0) {
        htmlContent += `<p style="font-weight: bold; color: #5cb85c; margin-top: 15px;">ลบได้:</p>`;
        htmlContent += `<ul style="list-style: none; padding-left: 0;">`;
        message.canDelete.forEach((item) => {
          htmlContent += `<li style="margin: 5px 0; padding: 5px; background: #d4edda; border-left: 3px solid #5cb85c;">
            <strong>${item.code || ""}</strong>: ${item.name || ""}
          </li>`;
        });
        htmlContent += `</ul>`;
      }

      if (message.question) {
        htmlContent += `<p style="font-weight: bold; margin-top: 20px; text-align: center;">${message.question}</p>`;
      }

      htmlContent += `</div>`;

      Swal.fire({
        html: htmlContent,
        icon,
        showCancelButton: true,
        buttonsStyling: true,
        customClass: {
          confirmButton: confirmButtonClass,
          cancelButton: cancelButtonClass,
        },
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (callback) callback(!!result.isConfirmed);
      });

      return;
    }
    case "C_DIALOG_MULTILINE": {
      icon = "info";
      confirmButtonClass = "btn btn-lg btn-success";
      cancelButtonClass = "btn btn-lg btn-danger";

      // แปลง \n -> <br/> เพื่อแบ่งบรรทัดตามที่พิมพ์
      const htmlMessage = String(message).replace(/\n/g, "<br/>");

      Swal.fire({
        html: htmlMessage,
        icon,
        showCancelButton: true,
        buttonsStyling: true,
        customClass: {
          title: "swal-title-lg",
          confirmButton: confirmButtonClass,
          cancelButton: cancelButtonClass,
        },
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (callback) callback(!!result.isConfirmed);
      });

      return;
    }

    default:
      console.error(`Invalid status: ${status}`);
      return;
  }

  // เลื่อนหน้าขึ้นด้านบนสุด
  window.scrollTo(0, 0);

  Swal.fire({
    title: message,
    icon: icon,
    buttonsStyling: false,
    customClass: {
      confirmButton: confirmButtonClass,
    },
  });
};

// ฟังก์ชันสำหรับจัดรูปแบบจำนวนเงิน
const formatCurrency = (amount, isItemPriceUnit = false) => {
  const decimalPlaces = isItemPriceUnit ? 4 : 2;

  // ถ้า amount เป็น string แล้วให้ return ออกเลย
  if (typeof amount === "string") {
    return amount;
  }

  if (typeof amount !== "number" || isNaN(amount)) {
    return decimalPlaces === 4 ? "0.0000" : "0.00";
  }

  const formattedAmount = amount.toFixed(decimalPlaces);

  return formattedAmount.replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

const parseCurrency = (formattedAmount) => {
  // ตรวจสอบว่า formattedAmount เป็น null หรือว่าง
  if (formattedAmount == null || formattedAmount === "") {
    return formattedAmount;
  }

  if (typeof formattedAmount === "number") return formattedAmount;
  if (typeof formattedAmount !== "string") return NaN;

  // ลบช่องว่างและเครื่องหมายพันหลัก ถ้าไปโดนฟังชั่น formatCurrency แปลงค่ามา
  const cleanedAmount = formattedAmount.replace(/,/g, "").trim();

  // แปลงค่ากลับไปเป็นตัวเลขเหมือนเดิม สมมุติ 100,400.00 จะแปลงเป็น 100400 (เคสที่พี่คินแจ้งมา)
  const numericValue = parseFloat(cleanedAmount);

  // ตรวจสอบว่าผลลัพธ์เป็นตัวเลขที่ถูกต้อง (ห้ามโยนกลับไปเป็น String เด็ดขาด ไม่งั้นเราจะชิปหายกันหมด)
  return isNaN(numericValue) ? formattedAmount : numericValue;
};

// ฟังก์ชั่นเพิ่ม DocNo (For PR, PO)
const getMaxDocNo = (list, title) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return title + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.Doc_No > max ? item.Doc_No : max;
  }, list[0].Doc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return title + currentYear + currentMonth + "0001";
  }

  return incrementDocNo(maxDoc);
};
// ฟังก์ชั่นเพิ่มเสริม DocNo (For PR, PO)
const incrementDocNo = (docNo) => {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
};

// ฟังก์ชั่นเพิ่ม RecNo
const getMaxRecNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `REC${currentYear}${currentMonth}0001`;
  }

  const maxRec = list.reduce((max, item) => {
    return item.Rec_No > max ? item.Rec_No : max;
  }, list[0].Rec_No);

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxRec.slice(3, 5) !== currentYear ||
    maxRec.slice(5, 7) !== currentMonth
  ) {
    return `REC${currentYear}${currentMonth}0001`;
  }

  return incrementRecNo(maxRec);
};
const getMaxRecNoForTest = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `REC${currentYear}${currentMonth}0001`;
  }

  const maxRec = list.reduce((max, item) => {
    return item.RecNo > max ? item.RecNo : max;
  }, list[0].RecNo);

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxRec.slice(3, 5) !== currentYear ||
    maxRec.slice(5, 7) !== currentMonth
  ) {
    return `REC${currentYear}${currentMonth}0001`;
  }

  return incrementRecNo(maxRec);
};
// ฟังก์ชั่นเพิ่มเสริม RecNo
const incrementRecNo = (recNo) => {
  const prefix = recNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(recNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
};

// ฟังก์ชั่นดึง Max ของ Pay
const getMaxPayNo = (list, givenDate) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  // แปลงวันที่จากรูปแบบ "13-09-2567" เป็นปีและเดือน
  let year, month;
  if (givenDate) {
    const [day, monthStr, yearStr] = givenDate.split("-");
    year = yearStr.slice(-2); // ดึงสองหลักสุดท้ายของปี พ.ศ.
    month = monthStr; // เดือน
  } else {
    year = currentYear;
    month = currentMonth;
  }

  // เช็คว่ามีข้อมูล Pay_No หรือไม่
  if (!list || list.length < 1) {
    return `PAY${year}${month}0001`;
  }

  // หาค่าสูงสุดของ Pay_No
  const maxPay = list.reduce((max, item) => {
    return item.Pay_No > max ? item.Pay_No : max;
  }, list[0].Pay_No);

  // เช็คปีและเดือนใน Pay_No ล่าสุด
  const maxPayYear = maxPay.slice(3, 5);
  const maxPayMonth = maxPay.slice(5, 7);

  if (maxPayYear !== year || maxPayMonth !== month) {
    return `PAY${year}${month}0001`;
  }

  return incrementPayNo(maxPay);
};
// ฟังก์ชั่นเพิ่มเสริม PayNo
const incrementPayNo = (payNo) => {
  const prefix = payNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(payNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
};

// ฟังก์ชั่นดึง Max ของ Line
const getLineByDocId = async (table, docId) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/get-line-by-doc-id`,
      {
        table: table,
        doc_id: docId,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ฟังก์ชั่นเพิ่ม AdjNo
const getMaxAdjNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `ADJ${currentYear}${currentMonth}0001`;
  }

  const maxAdj = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxAdj.slice(3, 5) !== currentYear ||
    maxAdj.slice(5, 7) !== currentMonth
  ) {
    return `ADJ${currentYear}${currentMonth}0001`;
  }

  return incrementAdjNo(maxAdj);
};
// ฟังก์ชั่นเพิ่มเสริม AdjNo
const incrementAdjNo = (adjNo) => {
  const prefix = adjNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(adjNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
};

// ฟังก์ชั่นเพิ่ม TnsNo
const getMaxTnsNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `TNS${currentYear}${currentMonth}0001`;
  }

  const maxTns = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน RecNo ล่าสุด
  if (
    maxTns.slice(3, 5) !== currentYear ||
    maxTns.slice(5, 7) !== currentMonth
  ) {
    return `TNS${currentYear}${currentMonth}0001`;
  }

  return incrementTnsNo(maxTns);
};
// ฟังก์ชั่นเพิ่มเสริม TnsNo
const incrementTnsNo = (tnsNo) => {
  const prefix = tnsNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(tnsNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
};

// ฟังก์ชั่นเพิ่ม AdjNo
const getMaxWDPNo = (list, prefix) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();
  const currentPrefix = `${prefix}${currentYear}${currentMonth}`;

  // กรองเฉพาะรายการที่ prefix ตรง
  const filteredList = list.filter((item) =>
    item.WHDoc_No.startsWith(currentPrefix),
  );

  if (filteredList.length === 0) {
    return `${currentPrefix}0001`;
  }

  const maxDoc = filteredList.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, filteredList[0].WHDoc_No);

  return incrementWDPNo(maxDoc);
};
// ฟังก์ชั่นเพิ่มเสริม AdjNo
const incrementWDPNo = (docNo) => {
  const prefix = docNo.slice(0, 7);
  const numPart = parseInt(docNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
};

// ฟังก์ชั่นเพิ่ม WhDocNo (For WD)
const getMaxWdNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "WD" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "WD" + currentYear + currentMonth + "0001";
  }

  return incrementWdNo(maxDoc);
};
// ฟังก์ชั่นเพิ่มเสริม WhDocNo (For WD)
const incrementWdNo = (docNo) => {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
};

// ฟังก์ชั่นเพิ่ม WTDocNo (For OD)
const getMaxOdNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "OD" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "OD" + currentYear + currentMonth + "0001";
  }

  return incrementOdNo(maxDoc);
};
// ฟังก์ชั่นเพิ่มเสริม WhDocNo (For OD)
const incrementOdNo = (docNo) => {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
};

// ฟังก์ชั่นเพิ่ม WhDocNo (For IB)
const getMaxIbNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "IB" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WHDoc_No > max ? item.WHDoc_No : max;
  }, list[0].WHDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "IB" + currentYear + currentMonth + "0001";
  }

  return incrementIbNo(maxDoc);
};
// ฟังก์ชั่นเพิ่มเสริม WhDocNo (For IB)
const incrementIbNo = (docNo) => {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
};

// ฟังก์ชั่นเพิ่ม WTDocNo (For TE)
const getMaxTeNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "TE" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WTDoc_No > max ? item.WTDoc_No : max;
  }, list[0].WTDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "TE" + currentYear + currentMonth + "0001";
  }

  return incrementTeNo(maxDoc);
};
// ฟังก์ชั่นเพิ่มเสริม WTDocNo (For TE)
const incrementTeNo = (docNo) => {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
};

// ฟังก์ชั่นเพิ่ม WTDocNo (For OE)
const getMaxOeNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "OE" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.WTDoc_No > max ? item.WTDoc_No : max;
  }, list[0].WTDoc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "OE" + currentYear + currentMonth + "0001";
  }

  return incrementOeNo(maxDoc);
};
// ฟังก์ชั่นเพิ่มเสริม WTDocNo (For OE)
const incrementOeNo = (docNo) => {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
};

// ฟังก์ชั่นเพิ่ม INV_H (For CS)
const getMaxCsNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return "CS" + currentYear + currentMonth + "0001";
  }

  const maxDoc = list.reduce((max, item) => {
    return item.Doc_No > max ? item.Doc_No : max;
  }, list[0].Doc_No);

  // เช็คปีและเดือนใน DocNo ล่าสุด
  if (
    maxDoc.slice(2, 4) !== currentYear ||
    maxDoc.slice(4, 6) !== currentMonth
  ) {
    return "CS" + currentYear + currentMonth + "0001";
  }

  return incrementCsNo(maxDoc);
};
// ฟังก์ชั่นเพิ่มเสริม INV_H (For CS)
const incrementCsNo = (docNo) => {
  const prefix = docNo.slice(0, 6); // รวมปีและเดือนใน prefix
  const numPart = parseInt(docNo.slice(6)) + 1;
  return prefix + numPart.toString().padStart(docNo.length - 6, "0");
};

// ฟังก์ชั่นเพิ่ม INV_H (For DSR)
const getMaxDsrNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `DSR${currentYear}${currentMonth}0001`;
  }

  const maxRec = list.reduce((max, item) => {
    return item.Doc_No > max ? item.Doc_No : max;
  }, list[0].Doc_No);

  // เช็คปีและเดือนใน InvNo ล่าสุด
  if (
    maxRec.slice(3, 5) !== currentYear ||
    maxRec.slice(5, 7) !== currentMonth
  ) {
    return `DSR${currentYear}${currentMonth}0001`;
  }

  return incrementDsrNo(maxRec);
};
// ฟังก์ชั่นเพิ่มเสริม INV_H (For DSR)
const incrementDsrNo = (invNo) => {
  const prefix = invNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(invNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
};

// ฟังก์ชั่นเพิ่ม InvNo
const getMaxInvNo = (list) => {
  const { currentYear, currentMonth } = getCurrentYearMonth();

  if (!list || list.length < 1) {
    // ตรวจสอบกรณี list เป็น undefined, null, หรือไม่มีข้อมูล
    return `INV${currentYear}${currentMonth}0001`;
  }

  const maxRec = list.reduce((max, item) => {
    return item.Doc_No > max ? item.Doc_No : max;
  }, list[0].Doc_No);

  // เช็คปีและเดือนใน InvNo ล่าสุด
  if (
    maxRec.slice(3, 5) !== currentYear ||
    maxRec.slice(5, 7) !== currentMonth
  ) {
    return `INV${currentYear}${currentMonth}0001`;
  }

  return incrementInvNo(maxRec);
};
// ฟังก์ชั่นเพิ่มเสริม InvNo
const incrementInvNo = (invNo) => {
  const prefix = invNo.slice(0, 7); // รวมปีและเดือนใน prefix
  const numPart = parseInt(invNo.slice(7)) + 1;
  return prefix + numPart.toString().padStart(4, "0");
};

// ฟังก์ชัน randomDelay ใช้สำหรับทดสอบหน่วงเวลาดึงเลข Doc_No เบื้องต้น (ใช้ชั่วคราวไปก่อน)
const randomDelay = () => {
  // const delay = Math.floor(Math.random() * 5000); // สุ่มหน่วงเวลา 0-5000 มิลลิวินาที
  // console.debug(`Random delay: ${delay} ms`);
  // return new Promise((resolve) => setTimeout(resolve, delay));
  return new Promise((resolve) =>
    setTimeout(resolve, Math.floor(Math.random() * 5000)),
  );
};

const getPriceForIce = (arCode, itemCode, itemQty) => {
  const aItemIce = ["101", "102", "103", "104"];

  let itemPrice = 0.0;
  let itemTotal = 0.0;
  let nPrice = 0.0;
  let cArSpriceUse = "N";
  let cItemSpriceUse = "Y";
  let nArSpriceId = 0;

  if (aItemIce.includes(itemCode)) {
    const result = getDataWithComp("Tb_Set_AR", `AND AR_Code = '${arCode}'`);

    if (result && result.length > 0) {
      nPrice = result[0].Default_Price || 0.0;
      cArSpriceUse = result[0].AR_SPrice_use || "N";
      nArSpriceId = result[0].AR_SPrice_id || 0;
    }
  }

  const itemResult = getDataWithComp(
    "Tb_Set_Item",
    `AND Item_Code = '${itemCode}'`,
  );

  if (itemResult && itemResult.length > 0) {
    cItemSpriceUse = itemResult[0].Item_SPrice_use || "Y";
    const nItemId = itemResult[0].Item_Id || 0;

    if (nPrice === 0.0) {
      itemPrice = itemResult[0].Item_Price || 0.0;
    } else {
      itemPrice = nPrice;
    }

    let nProQty = 0.0;
    let nProPrice = 0.0;

    if (cArSpriceUse === "Y" && cItemSpriceUse === "Y") {
      const sPriceResult = getDataWithComp(
        "Tb_Set_ItemSPrice",
        `AND sp_id = ${nArSpriceId} AND item_id = ${nItemId}`,
      );

      if (sPriceResult.length > 0) {
        nProQty = sPriceResult[0].pro_qty || 0.0;
        nProPrice = sPriceResult[0].pro_price || 0.0;

        if (sPriceResult[0].itemsp_price > 0.0) {
          itemPrice = sPriceResult[0].itemsp_price;
        }
      }
    }

    if (nProQty <= 0.0) {
      itemTotal = itemPrice * itemQty;
    } else {
      const n = Math.floor(itemQty / nProQty);
      itemTotal = n * nProPrice + (itemQty - n * nProQty) * itemPrice;
    }
  }

  return itemTotal;
};

// Update Status ในข้อมูล
const updateStatusByNo = async (table, field, status, where) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/update-status`,
      {
        table: table,
        field: field,
        status: status,
        where: where,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// Update Qty ในข้อมูล
const updateQty = async (table, updateCode, where) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/update-qty`,
      {
        table: table,
        update_code: updateCode,
        where: where,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// Insert ข้อมูลด้วย Table, Field, Values
const insertData = async (table, field, values) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/create-data`,
      {
        table: table,
        field: field,
        values: values,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );

    console.debug("✅ insertData response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ insertData error:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      statusText: error.response?.statusText,
      table,
      field,
      values,
    });

    // คืนค่า error object แทน null เพื่อให้ caller รู้ว่าเกิด error อะไร
    return {
      ok: false,
      error:
        error.response?.data?.error ||
        error.message ||
        "เกิดข้อผิดพลาดในการบันทึกข้อมูล",
      details: error.response?.data,
    };
  }
};

// Update ข้อมูลด้วย Table, Values, Where
const updateData = async (table, values, where) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/update-data`,
      {
        table: table,
        values: values,
        where: where,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    console.debug("updateData ", response);
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// Delete ข้อมูลด้วย Table, Where
const deleteData = async (table, where) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/delete`,
      {
        table: table,
        where: where,
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );
    console.debug("deleteData ", response);
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

// ฟังชั่นการสร้าง Tb_Set_Rec_No ใช้ชั่วคราว (จากพี่แบงค์)
const createSetRecNo = async (recNo) => {
  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_API_URL}/api/create-tb-set-rec-no`,
      {
        rec_no: recNo,
        comp_id: window.localStorage.getItem("company"),
      },
      {
        headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};
export function useEscapeClose(isOpen, onClose) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);
}

export {
  getData,
  getDataWithComp,
  getDataWithJoin,
  searchItemsWithStock,
  countData,
  getByDocId,
  getByRecId,
  getByPayId,
  getCompany,
  getDocType,
  getTransType,
  getDocStatusColour,
  getViewPrH,
  getViewPoH,
  getViewAp,
  getViewItem,
  getSoWithoutPK,
  getCustByType,
  getEmpByType,
  getAlert,
  formatCurrency,
  parseCurrency,
  getMaxDocNo,
  getMaxRecNo,
  getMaxRecNoForTest,
  getMaxPayNo,
  getLineByDocId,
  getMaxAdjNo,
  getMaxTnsNo,
  getMaxWdNo,
  getMaxOdNo,
  getMaxIbNo,
  getMaxTeNo,
  getMaxOeNo,
  getMaxCsNo,
  getMaxDsrNo,
  getMaxInvNo,
  randomDelay,
  getPriceForIce,
  updateStatusByNo,
  updateQty,
  insertData,
  updateData,
  deleteData,
  createSetRecNo,
  getMaxWDPNo,
};
